const compactAddressParts = (parts = []) => parts
  .map(part => String(part || '').trim())
  .filter(Boolean);

const regionValue = (address = {}, field) => {
  const directValue = address[field];
  const englishValue = address[`${field}En`];
  const idValue = address[`${field}Id`];
  const codeValue = address[`${field}Code`];
  return directValue || englishValue || idValue || codeValue || '';
};

export function formatAddressForList(address = {}) {
  return formatAddressForOrder(address);
}

export function formatAddressForOrder(address = {}, fallback = '') {
  return compactAddressParts([
    address.detailedAddress,
    regionValue(address, 'region'),
    regionValue(address, 'city'),
    regionValue(address, 'province'),
  ]).join(', ') || fallback;
}
